const BATOUTA = 'https://backend-batouta.pmc.tn/';
const MSGI = 'http://srv-msgi.pmc.tn/';
const MSGI2 = 'https://srv2-msgi.pmc.tn/';
const UNIGES = 'https://backend-uniges.pmc.tn/';
const KASTELO = 'http://197.14.12.130:82/';
const KARAKAC = 'http://127.0.0.1:5000/';
const MATEM = 'http://196.179.253.217:85/';
const SIMED = 'http://192.168.0.161:92/';
const CURRENT_USER = UNIGES;
export const environment = {
  production: false,
  apiEndPoint: CURRENT_USER + 'api/',
  flatEndPoint: CURRENT_USER,
  hubEndPoint: CURRENT_USER + 'hub/',
};
